import { createContext, PropsWithChildren, useContext } from 'react';
import { useEnergyWorker } from '../../hooks/useEnergyWorker';

export type CounterType = {
  hours: number
  minutes: number
  seconds: number
  formatedSecond: string
  formatedMinutes: string
  isFinished: boolean
}
interface EnergyContextProps {
  userEnergy: number,
  energyRecoveryPerSecond: number,
  maxEnergy: number,
  energyForSpin: number,
  counter:CounterType
}

const EnergyContext = createContext({} as EnergyContextProps);

export const useEnergyContext = () => {
  const ctx = useContext(EnergyContext);

  if (!ctx) {
    throw new Error(
      'useAutopilotContext must be used within an EnergyProvider',
    );
  }

  return ctx;
};

function EnergyProvider({ children }: PropsWithChildren) {
  const energyData = useEnergyWorker();
  return (
    <EnergyContext.Provider value={energyData}>
      {children}
    </EnergyContext.Provider>
  );
}

export default EnergyProvider;
